export const getInsertionOrdersNextPageParam = (
  lastPage: ListInsertionOrdersResponse
): number | undefined =>
  lastPage?.currentPage + 1 <= lastPage?.pages
    ? lastPage?.currentPage + 1
    : undefined
